import React from "react";
import SVGFoundation from "../../../svg-foundation/svg-foundation";
export default class News extends SVGFoundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
            titleText: void 0,
        };
    }
    render() {
        return (React.createElement("svg", Object.assign({}, this.unhandledProps()),
            this.renderTitleText(this.props),
            React.createElement("path", { 
                /* tslint:disable-next-line */
                d: "M16 4V11C16 11.276 15.9453 11.5365 15.8359 11.7812C15.7318 12.0208 15.5885 12.2318 15.4062 12.4141C15.2292 12.5911 15.0182 12.7344 14.7734 12.8438C14.5286 12.9479 14.2708 13 14 13H1.94531C1.67969 13 1.42708 12.9479 1.1875 12.8438C0.953125 12.7396 0.747396 12.6016 0.570312 12.4297C0.398438 12.2526 0.260417 12.0469 0.15625 11.8125C0.0520833 11.5729 0 11.3203 0 11.0547V2H14V4H16ZM15 5H14V10.5C14 10.6354 13.9505 10.7526 13.8516 10.8516C13.7526 10.9505 13.6354 11 13.5 11C13.3646 11 13.2474 10.9505 13.1484 10.8516C13.0495 10.7526 13 10.6354 13 10.5V3H1V11.0547C1 11.1849 1.02344 11.3073 1.07031 11.4219C1.1224 11.5365 1.1901 11.638 1.27344 11.7266C1.36198 11.8099 1.46354 11.8776 1.57812 11.9297C1.69271 11.9766 1.8151 12 1.94531 12H14C14.1406 12 14.2708 11.974 14.3906 11.9219C14.5104 11.8698 14.6146 11.7995 14.7031 11.7109C14.7969 11.6172 14.8698 11.5104 14.9219 11.3906C14.974 11.2708 15 11.1406 15 11V5ZM12 5H2V4H12V5ZM12 11H8V10H12V11ZM12 9H8V8H12V9ZM12 7H8V6H12V7ZM7 11H2V5.97656H7V11ZM3 10H6V6.97656H3V10Z" })));
    }
}
